import { createSvgIcon } from '@mui/material/utils'

const SynopLinkIcon = createSvgIcon(
  <>
    <path d="M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9zm-4 10H4V5h14v14z" />
    <path d="M12.5 7L7.5 13.5h3.25L10 17.5l5.5-6.5h-3.5z" />
  </>,
  'SynopLink'
)

export default SynopLinkIcon
